import { createSlice } from '@reduxjs/toolkit';
import { addAdminApi } from '../../../rtk-apis/clinics/addAdmin';

const initialState = {
  status: '',
  result: '',
  msg: '',
  loading: false,
};

const addAdminSlice = createSlice({
  name: 'addAdmin',
  initialState,
  reducers: {
    clearAdminState: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(addAdminApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addAdminApi.fulfilled, (state, action) => {
        console.log(action);
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = action?.payload?.msg || 'User added successfully.';
      })
      .addCase(addAdminApi.rejected, (state, { payload }) => {
        console.log('payload', payload);
        state.loading = false;
        state.status = 'FAILED';
        state.msg = (payload as string) ?? 'Failed';
      });
  },
});

export const { clearAdminState } = addAdminSlice.actions;
export default addAdminSlice.reducer;
